import { Hardware, HardwareType, ScannerDetails } from "../insurgo-interfaces/hardware.interface";

export class InvestigoScanner {

  databaseID: number = 0;
  isBarcodeEnabled: boolean = false;
  serialNumber: string = '';
  assetTag: string = '';
  dispatchReference: string = '';
  ccSentDate: Date | null = null;

  constructor(hardwareItem: Hardware) {
    if (hardwareItem.HardwareTypeID !== HardwareType.SCANNER) {
      throw new Error('This is not a scanner');
    }

    if (hardwareItem.OtherDetails.model === 'TS1-B') {
      this.isBarcodeEnabled = true;
    }
    this.serialNumber = hardwareItem.SerialNumber;
    this.assetTag = hardwareItem.AssetTag;
    this.databaseID = hardwareItem.HardwareRegisterID;


    const ccSentDateSec = hardwareItem.CCSentDateSec as number;
    if (ccSentDateSec) {
      this.ccSentDate = new Date(ccSentDateSec * 1000);
    } else {
      this.ccSentDate = null;
    }

    if ('dispatchReference' in hardwareItem.OtherDetails) {
      this.dispatchReference = hardwareItem.OtherDetails.dispatchReference as string;
    }

  }
}